import { useReactiveVar } from '@apollo/client';
import type { Serializable } from '@frameio/utils';
import type { ReactiveMap } from './ReactiveMap';

/** provides updates to components when a particular reactive value changes at a
 * given key in a ReactiveMap */
export const useReactiveMap = <
  K extends string = string,
  T extends Serializable = Serializable,
>(
  map: ReactiveMap<K, T>,
  key: K
) => {
  return useReactiveVar(map.getVar(key));
};
